// Klasser för komponenten <eui-pop-up-meny>:


//###################################################################################################
// Typer av "meny-delar":

// En metod att få "enum" i JavaScript:
const delTypEnum = Object.freeze({
	EVENT:		0,
	LANK:			1,
	UNDERMENY:	2,
	KOMPONENT:	3,
	LINJE:		4,
});


//###################################################################################################
// "Private" hjälpklass för delTypEnum

const _delTypHelpers = {
	_godkandaTyperEnumvarden: [
		delTypEnum.EVENT,
		delTypEnum.LANK,
		delTypEnum.UNDERMENY,
		delTypEnum.KOMPONENT,
		delTypEnum.LINJE,
	],

	arGodkandTyp(typEnumvarde) {
		return this._godkandaTyperEnumvarden.indexOf(typEnumvarde) !== -1;
	},
}


//###################################################################################################
// En enskild meny:

class menyConfigClass
{
	constructor(menydelar)
	{
		// Först lite basic typkontroller av parametrarna: ---------------------------

		// Alt: Array.isArray(menydelar)
		console.assert(menydelar instanceof Array,
			'Parametern \'menydelar\' är obligatorisk och måste vara av typen \'Array\'.'
		);

		console.assert(menydelar.every(val => val instanceof _delBase),
			'Alla värden i arrayen \'menydelar\' måste vara av typen \'_delBase\'.'
		);

		// ---------------------------------------------------------------------------


		this.menydelar = menydelar;

		// Ersatt ovan:
		//// Knapparna adderas medelst iteration, för att typechecka dem en och en:
		//// Om att iterera arrayer (med for-of i detta fall):
		//// https://stackoverflow.com/questions/9329446/for-each-over-an-array-in-javascript
		//for (var del of menydelar){
		//	//if (!(del instanceof _delBase))
		//	//{
		//	//	const feltext = `Menydelen '${del}' är inte en instans av klassen '_delBase'.`;
		//	//	console.error(feltext);
		//	//	throw new TypeError(feltext);
		//	//}

		//	this.menydelar.push(del);
		//}

		// Kolla att varje del med eventId har ett unikt sådant:
		// Todo: Detta ska ändras så att unikiteten är per eventId + eventData. Fixat snabbt med en '+' av värdena nedan:

		// SO: https://stackoverflow.com/a/30735595/593779
		// "Here, we insert each and every object's name into the Set and we check if the size before and after adding are the same. This works because Set.size returns a number based on unique data (set only adds entries if the data is unique). If/when you have duplicate names, the size won't increase (because the data won't be unique) which means that we would have already seen the current name and it will return true."

		let seen = new Set();

		// The some() method tests whether at least one element in the array passes the test implemented by the provided function:
		let hasDuplicates = this.menydelar.filter((item) => { return item.eventId !== undefined; })
			.some((currentObject) => {
				return seen.size === seen.add(currentObject.eventId + JSON.stringify(currentObject.eventData)).size;
			}
		);

		console.assert(!hasDuplicates,
			'Det finns minst en menydel som har ett icke-unikt event-id (i kombination med event-data).',
			this.menydelar
		);

		this.uppdateraMenydelIndex();
	}

	// ==========================================================

	get antalMenydelar()
	{
		return this.menydelar.length;
	}

	// ==========================================================

	// Static method för att efterlikna copy constructor/cast (från ett korrekt object som dock bara inte är av typen menyConfigClass):
	static castFrom(obj,
		// Named (but not and optional) parameters (med eventuella default satta), as options object:
		{
			castAlsoNestedObjectsAndArrayValues,
		}
		= {}	// Default för den optional options-parametern som sådan.
	)
	{
		// Först lite basic typkontroller av parametrarna: ---------------------------

		console.assert(typeof obj === 'object',
			'Parametern \'obj\' är obligatorisk och måste vara av typen \'object\'.'
		);

		console.assert(typeof castAlsoNestedObjectsAndArrayValues === 'boolean',
			'Parametern \'castAlsoNestedObjectsAndArrayValues\' är obligatorisk och måste vara av typen \'boolean\'.'
		);

		// ---------------------------------------------------------------------------

		if (!castAlsoNestedObjectsAndArrayValues)
		{
			// Om bara rotobjektet ska "castas":
			// Obs! Denna "castar" *endast* rotobjektet, inte nästade underobjekt/arrayvärden!
			let ny = new menyConfigClass([]);		// [] här för parameterkontrollen (obligatorisk) ovan.
			ny = Object.assign(ny, obj);
			ny.uppdateraMenydelIndex();

			return ny;
		}
		else
		{
			// Annars:
			// Obs! Till skillnad från if-benet ovan "castar" denna både rotobjektet *och* alla nästade underobjekt/arrayvärden!

			const stringifierat = JSON.stringify(obj);

			// You can use the optional reviver argument to filter or post-process the parsed value before it is returned.
			// If it is specified, the reviver function is invoked once for each primitive value (but not the objects or arrays that contain those primitive values) parsed from s. reviver is invoked with two arguments. The first is a property name—either an object property name or an array index converted to a string. The second argument is the primitive value of that object property or array element. reviver is invoked as a method of the object or array that contains the primitive value. As a special case, if the string s represents a primitive value rather than the more typical object or array, then that primitive value will be stored in a newly-created object using a property whose name is the empty string. In this case, reviver will be invoked once on that newly created object, with an empty string as its first argument and the primitive value as its second.

			const ny = JSON.parse(stringifierat, (key, value) =>
			{
				// Riviver function:
				// Se https://abdulapopoola.com/2018/02/26/what-you-didnt-know-about-json-parse/

				//console.log(`${key} : ${value}`, typeof key, typeof value);

				if ((key === 'undermenyConfig' && !!value)
					|| key === ''
				)
				{
					// Om det är ett undermeny-objekt OCH värde finns
					// ELLER det är själva rotobjektet:
					return this.castFrom(value, { castAlsoNestedObjectsAndArrayValues: false });	// Nästade objekt/arrayvärden hanteras av denna riviverfunktionen som sådan!
				}

				// Obs! Denna (isNaN(key)) *måste* ligga *efter* '' ovan för isNaN('') === false ('' betraktas som 0, se https://stackoverflow.com/a/175787/593779):

				if (!isNaN(key)
					// Dessa två för att säkerställa att det är en array av en viss typ, vilket här egentligen är onödigt, för i det nästade rotobjektet förekommer endast en typ av array:
					&& typeof value === 'object'
					&& value.hasOwnProperty('eventId')
				)
				{
					// Om det är ett array-värde
					// OCH det finns i en array som har object-värden med den "arraytypsunika" propertyn 'eventId' (= det är en menydel):
					return _delBase.castFrom(value, { castAlsoNestedObjectsAndArrayValues: false });	// Nästade objekt/arrayvärden hanteras av denna riviverfunktionen som sådan!);
				}

				// Annars returnera bara värdet:
				return value;
			});

			//console.log('ROTEN:', ny);

			return ny;
		}
	}

	// ==========================================================

	uppdateraMenydelIndex()
	{
		for (let i = 0; i < this.antalMenydelar; i++)
		{
			this.menydelar[i].index = i;
		}
	}

	stangAllaUndermenyer()
	{
		for (let i = 0; i < this.antalMenydelar; i++)
		{
			this.menydelar[i].visaUndermenyn = false;
		}
	}

	stangUndermenynForMenydel(menydelIndex)
	{
		this.menydelar[menydelIndex].visaUndermenyn = false;
	}

	visaUndermenynForMenydelOchStangEvAndra(menydelIndex)
	{
		for (let i = 0; i < this.antalMenydelar; i++)
		{
			this.menydelar[i].visaUndermenyn = (i === menydelIndex);
		}
	}
}

//###################################################################################################
// En enskild "meny-del", av godtycklig typ ("Private" "basklass"):

class _delBase
{
	constructor(typ,
		// Named and optional parameters (med eventuella default satta), as options object:
		{
			text,
			ikon,
			eventId,
			eventData,
			lank,
			nyttFonster,
			cssModifierClass,
			disabled = false,
			checked = false,
			tooltip,
			komponentnamn,
			komponentProps,
			undermenyConfig,
		}
		= {}	// Default för den optional options-parametern som sådan.
	)
	{
		console.assert(_delTypHelpers.arGodkandTyp(typ),
			`Det finns ingen menydelstyp med enum-värdet '${typ}'.`
		);

		this.typ = typ;
		this.eventId = eventId;
		this.eventData = eventData;
		this.ikon = ikon;
		this.text = text;
		this.lank = lank;
		this.nyttFonster = nyttFonster;
		this.cssModifierClass = cssModifierClass;
		this.disabled = disabled;
		this.checked = checked;
		this.tooltip = tooltip;

		this.komponentnamn = komponentnamn;
		this.komponentProps = komponentProps;

		this.undermenyConfig = undermenyConfig;
		this.visaUndermenyn = false;

		this.index = undefined;		// Denna sätts när en array med menydelar används i menyConfigClass, av dess constructor!
	}

	// ==========================================================

	get arAvTypEvent() {
		return this.typ === delTypEnum.EVENT;
	}

	get arAvTypLank() {
		return this.typ === delTypEnum.LANK;
	}

	get arAvTypEventEllerLank() {
		return (this.arAvTypEvent || this.arAvTypLank);
	}


	get arAvTypUndermeny() {
		return this.typ === delTypEnum.UNDERMENY;
	}

	get arAvTypLinje() {
		return this.typ === delTypEnum.LINJE;
	}

	get arAvTypKomponent() {
		return this.typ === delTypEnum.KOMPONENT;
	}

	// ==========================================================

	// Static method för att efterlikna copy constructor/cast (från ett korrekt object som dock bara inte är av typen _delBase):
	static castFrom(obj,
		// Named (but not and optional) parameters, as options object:
		{
			castAlsoNestedObjectsAndArrayValues,
		}
	)
	{
		// Först lite basic typkontroller av parametrarna: ---------------------------

		console.assert(typeof obj === 'object',
			'Parametern \'obj\' är obligatorisk och måste vara av typen \'object\'.'
		);

		console.assert(typeof castAlsoNestedObjectsAndArrayValues === 'boolean',
			'Parametern \'castAlsoNestedObjectsAndArrayValues\' är obligatorisk och måste vara av typen \'boolean\'.'
		);

		// ---------------------------------------------------------------------------

		if (!castAlsoNestedObjectsAndArrayValues)
		{
			// Om bara rotobjektet ska "castas":
			// Obs! Denna "castar" *endast* rotobjektet, inte nästade underobjekt/arrayvärden!
			let ny = new _delBase(0);		// 0 här för parameterkontrollen (obligatorisk) ovan. Detta värde (typ) ersätts sedan vid assign() nedan.
			ny = Object.assign(ny, obj);
			return ny;
		}
		else
		{
			// Annars:
			// Obs! Till skillnad från if-benet ovan "castar" denna både rotobjektet *och* alla nästade underobjekt/arrayvärden!

			const stringifierat = JSON.stringify(obj);

			// You can use the optional reviver argument to filter or post-process the parsed value before it is returned.
			// If it is specified, the reviver function is invoked once for each primitive value (but not the objects or arrays that contain those primitive values) parsed from s. reviver is invoked with two arguments. The first is a property name—either an object property name or an array index converted to a string. The second argument is the primitive value of that object property or array element. reviver is invoked as a method of the object or array that contains the primitive value. As a special case, if the string s represents a primitive value rather than the more typical object or array, then that primitive value will be stored in a newly-created object using a property whose name is the empty string. In this case, reviver will be invoked once on that newly created object, with an empty string as its first argument and the primitive value as its second.

			const ny = JSON.parse(stringifierat, (key, value) =>
			{
				// Riviver function:

				//console.log(`${key} : ${value}`, typeof key, typeof value);

				if (key === 'undermenyConfig' && !!value)
				{
					// Om det är ett undermeny-objekt OCH värde finns:
					return this.castFrom(value, { castAlsoNestedObjectsAndArrayValues: false });	// Nästade objekt/arrayvärden hanteras av denna riviverfunktionen som sådan!
				}

				// Normalt gäller detta, *om* rotobjektet är av en typ och innehåller array(er) av annan typ, men här är de samma, så det gäller inte här. Låter stå kvar för ev framtida copy-paste ;) :
				// Obs! Denna (isNaN(key)) *måste* ligga *efter* '' ovan för isNaN('') === false ('' betraktas som 0, se https://stackoverflow.com/a/175787/593779):

				if (key === ''
					|| (!isNaN(key)
						// Dessa två för att säkerställa att det är en array av en viss typ, vilket här egentligen är onödigt, för i det nästade rotobjektet förekommer endast en typ av array:
						&& typeof value === 'object'
						&& value.hasOwnProperty('eventId')
					)
				)
				{
					// Om det är själva rotobjektet
					// ELLER det är ett array-värde
					//		OCH det finns i en array som har object-värden med den "arraytypsunika" propertyn 'eventId' (= det är en menydel):
					return _delBase.castFrom(value, { castAlsoNestedObjectsAndArrayValues: false });	// Nästade objekt/arrayvärden hanteras av denna riviverfunktionen som sådan!);
				}

				// Annars returnera bara värdet:
				return value;
			});

			//console.log('ROTEN:', ny);

			return ny;
		}
	}
}

//###################################################################################################
// Ett Event-alternativ (enskild meny-del):

class delEventClass extends _delBase
{
	constructor(text, eventId,
		// Named and optional parameters (med eventuella default satta), as options object:
		{
			ikon,
			eventData,
			cssModifierClass,
			disabled = false,
			checked = false,
			tooltip,
		}
		= {}	// Default för den optional options-parametern som sådan.
	)
	{
		super(delTypEnum.EVENT, {
			text: text,
			ikon: ikon,
			eventId: eventId,
			eventData: eventData,
			cssModifierClass: cssModifierClass,
			disabled: disabled,
			checked: checked,
			tooltip: tooltip,
		});
	}
}

//###################################################################################################
// Ett Lank-alternativ (enskild meny-del):

class delLankClass extends _delBase
{
	constructor(text, lank,
		// Named and optional parameters (med eventuella default satta), as options object:
		{
			ikon,
			cssModifierClass,
			disabled = false,
			checked = false,
			tooltip,
			nyttFonster = false,
		}
		= {}	// Default för den optional options-parametern som sådan.
	)
	{
		super(delTypEnum.LANK, {
			text: text,
			ikon: ikon,
			lank: lank,
			nyttFonster: nyttFonster,
			cssModifierClass: cssModifierClass,
			disabled: disabled,
			checked: checked,
			tooltip: tooltip,
		});
	}
}

//###################################################################################################
// Ett alternativ (enskild meny-del) som har en undermeny:

class delUndermenyClass extends _delBase
{
	constructor(text, undermenyConfig,
		// Named and optional parameters (med eventuella default satta), as options object:
		{
			ikon,
			cssModifierClass,
			disabled = false,
			checked = false,
			tooltip,
		}
		= {}	// Default för den optional options-parametern som sådan.
	)
	{
		console.assert(undermenyConfig instanceof menyConfigClass,
			'Parametern \'undermenyConfig\' är obligatorisk och måste vara av typen \'menyConfigClass\'.'
		);

		super(delTypEnum.UNDERMENY, {
			text: text,
			ikon: ikon,
			//lank: lank,
			cssModifierClass: cssModifierClass,
			disabled: disabled,
			checked: checked,
			tooltip: tooltip,
			undermenyConfig: undermenyConfig,
		});
	}
}

//###################################################################################################
// En komponent (enskild meny-del):

class delKomponentClass extends _delBase
{
	constructor(komponentnamn,
		// Named and optional parameters (med eventuella default satta), as options object:
		{
			komponentProps,
		}
		= {}	// Default för den optional options-parametern som sådan.
	)
	{
		super(delTypEnum.KOMPONENT, {
			komponentnamn: komponentnamn,
			komponentProps: komponentProps,
		});
	}
}

//###################################################################################################
// En linje (enskild meny-del):

class delLinjeClass extends _delBase
{
	constructor()
	{
		super(delTypEnum.LINJE);
	}
}



export default {
	delTypEnum: delTypEnum,
	menyConfig: menyConfigClass,
	delEvent: delEventClass,
	delLank: delLankClass,
	delUndermeny: delUndermenyClass,
	delKomponent: delKomponentClass,
	delLinje: delLinjeClass,
}

